import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { FiInstagram } from "react-icons/fi"
import { FaFacebookF, FaTwitter } from "react-icons/fa"
import "./SocialIcon.css"

export default function SocialIcon({ type, color = "default", classes = "" }) {
  return (
    <StaticQuery
      query={graphql`
        query SocialIconsQuery {
          settings: sanitySiteSettings {
            facebookURL
            instagramURL
            twitterURL
          }
        }
      `}
      render={data => {
        const { facebookURL, instagramURL, twitterURL } = data.settings
        return (
          <>
            {type === "facebook" && (
              <a
                href={instagramURL}
                target="_blank"
                rel="noreferrer"
                className={`nav-link self-center ${classes}`}
              >
                <FiInstagram
                  className={`${
                    color === "default"
                      ? "text-brands-instagram"
                      : "color-" + color
                  }`}
                />
              </a>
            )}
            {type === "instagram" && (
              <a
                href={facebookURL}
                target="_blank"
                rel="noreferrer"
                className={`nav-link self-center ${classes}`}
              >
                <FaFacebookF
                  className={`${
                    color === "default"
                      ? "text-brands-facebook"
                      : "color-" + color
                  }`}
                />
              </a>
            )}
            {type === "twitter" && (
              <a
                href={twitterURL}
                target="_blank"
                rel="noreferrer"
                className={`nav-link self-center ${classes}`}
              >
                <FaTwitter
                  className={`${
                    color === "default"
                      ? "text-brands-twitter"
                      : "color-" + color
                  }`}
                />
              </a>
            )}
          </>
        )
      }}
    />
  )
}
